import { addGlobalThemeStyles } from '@vaadin/vaadin-themable-mixin/register-styles.js';

export const addLumoGlobalStyles = (id, ...styles) => {
  addGlobalThemeStyles(`lumo-${id}`, styles);
};
